<div class="mapContainerNode">
    <div id="viewport" #viewport></div>
</div>
<ng-container #overlay></ng-container>
